import { useCallback, useState } from 'react'
import { FiTrash2, FiX } from 'react-icons/fi'

import { Button } from '~/components/Button'
import { Modal } from '~/components/Modal'
import { LicenseExtension } from '~/modules/sales/licenseExtensions/types'

type Props = {
  extension: LicenseExtension
  onDelete: () => void
}

export const DeleteLicenseExtensionButton: React.FC<Props> = ({
  extension,
  onDelete,
}) => {
  const [showConfirm, setShowConfirm] = useState(false)

  const handleConfirm = useCallback(() => {
    setShowConfirm(false)
    onDelete()
  }, [onDelete])

  return (
    <>
      <button
        className='py-2 px-4 rounded-md bg-gpa-red hover:bg-red-500 text-white'
        onClick={() => setShowConfirm(true)}
      >
        <FiTrash2 size={18} />
      </button>
      <Modal visible={showConfirm}>
        <div className='grid gap-4'>
          <div className='flex items-center justify-between mb-4'>
            <h1 className='text-xl'>Desativar pacote</h1>
            <button
              type='button'
              className='p-2 rounded-full hover:bg-slate-50'
              onClick={() => setShowConfirm(false)}
            >
              <FiX size={26} />
            </button>
          </div>
          <p>
            Tem certeza que deseja desativar{' '}
            <strong>{extension.name}</strong>? O pacote deixará de aparecer
            para os personal trainers mas o histórico de compras é preservado.
          </p>
          <div className='flex justify-end'>
            <Button
              type='button'
              color='error'
              onClick={handleConfirm}
              loadingMessage='Desativando...'
            >
              Desativar
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}
